module.exports = __webpack_public_path__ + "static/media/valor2.0c0341b5.png";